import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=191b8b6a&scoped=true&"
import script from "./regions.vue?vue&type=script&lang=js&"
export * from "./regions.vue?vue&type=script&lang=js&"
import style0 from "./regions.vue?vue&type=style&index=0&id=191b8b6a&lang=scss&scoped=true&"
import style1 from "./regions.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./regions.vue?vue&type=style&index=2&id=191b8b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b8b6a",
  null
  
)

export default component.exports